<template>
	<div class="w-100 my-5 py-4">
		<loader />
	</div>
</template>
<script>
	import {mapMutations,mapGetters} from 'vuex'
	import moment from 'moment'
	export default{
		metaInfo(){
      return {title:'Loading...'}
    },
		mounted(){
			let guest = {
				adult: 1,
				child: 0,
				infant: 0,
			}
			if (this.$route.query.guest){
				let guest_query = this.$route.query.guest.split('-')
				guest = {
					adult: Number(guest_query[0]),
					child: Number(guest_query[1]),
					infant: Number(guest_query[2]),
				}
      }
			let params = {
				date: {
					check_in: this.$route.params.check_in,
					check_out: this.$route.params.check_out,
				},
				guest: guest,
				promo_code: this.$route.params.promo_code == 'promo_code_empty' ? '' : this.$route.params.promo_code 
			}
			// Validasi
			if (moment(params.date.check_out).isSameOrBefore(params.date.check_in)) {
				params.date.check_out = moment(params.date.check_in).add(this.$defaultFilterBE('night'), 'd').toDate()
				params.date.check_in = moment(params.date.check_in).format("YYYY-MM-DD")
				params.date.check_out = moment(params.date.check_out).format("YYYY-MM-DD")
			}
			this.setBeFilter(params)
			this.resetBECart()
			this.setBeSortBy('room_type')
			this.setBeFilterDetail({
				type: 'room_type',
				data: {}
			})
			this.setBeFirstLoad(false)
			setTimeout(() =>{
				let is_home = this.$route.query.is_home 
				console.log("is_home :", is_home)
				if(is_home){
					console.log("A")
					this.$router.push({
						name : 'MerchantHome'
					})
				}else{
					console.log("B")
					this.$router.push({
						name : 'BERoom'
					})
				}
			},300)
		},
		methods:{
			...mapMutations(['setBeFilter','resetBECart','setBeSortBy','setBeFilterDetail','setBeFirstLoad']),
			...mapGetters(['getMerchant'])
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/hotel/be/BeDirectFilter.vue